"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInsightErrorSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
exports.IInsightErrorSchema = zod_1.default.object({
    id: zod_1.default.string(),
    errorId: zod_1.default.string(),
    level: _1.DesignModels.BoundaryLevelSchema,
    message: zod_1.default.string(),
    circuitState: zod_1.default.lazy(() => _1.SerializedCircuitStateOrPointerSchema).optional(),
    circuitObjects: zod_1.default
        .lazy(() => _1.DesignModels.IBoundaryErrorCircuitObjectSchema)
        .array()
        .optional(),
    innerError: zod_1.default.lazy(() => exports.IInsightErrorSchema).optional(),
});
//# sourceMappingURL=IInsightError.js.map